import * as Yup from "yup";

const MIN_NAME_LENGTH: number = 5;
const MAX_NAME_LENGTH: number = 50;
const MIN_DESCRIPTION_LENGTH: number = 5;
const MAX_DESCRIPTION_LENGTH: number = 250;

const editOrganisationValidator = Yup.object({
    name : Yup.string()
        .required("Name is Required")
        .min(
            MIN_NAME_LENGTH,
            `Name must be at least ${MIN_NAME_LENGTH} characters long`
        )
        .max(
            MAX_NAME_LENGTH,
            `Name must be less than ${MAX_NAME_LENGTH} characters long`
        ),
    description : Yup.string()
        .required("Description is Required")
        .min(
            MIN_DESCRIPTION_LENGTH,
            `Description must be at least ${MIN_DESCRIPTION_LENGTH} characters long`
        )
        .max(
            MAX_DESCRIPTION_LENGTH,
            `Description must be less than ${MAX_DESCRIPTION_LENGTH} characters long`
        ),
});

export default editOrganisationValidator;